import { IMetaResource } from '@enuan/chat__utils';
import { Audio } from '../../../message/content';
import { Download } from './Download';

export const AudioBalloonContent = ({
	data,
	isVoice,
}: {
	data: IMetaResource;
	isVoice: boolean;
}) => {
	return (
		<Audio resource={data} hideName={isVoice}>
			<Download data={data} />
		</Audio>
	);
};
